export const TOKENREFRESHINTERVAL: number = Number(
  process.env.REACT_APP_RIVERUS_CLM_APP_TOKEN_REFRESH_INTERVAL
); // Refresh tokens in 3 minutes
export const TOKENEXPIRYDURATION: number = Number(
  process.env.REACT_APP_RIVERUS_CLM_APP_TOKEN_EXPIRY_DURATION
); // Token actually expires after 5 minutes

export const AUTHAPI = process.env.REACT_APP_AUTH_API;

export const SITEAPI =
  process.env.REACT_APP_RIVERUS_CLM_API + 'my-realm' + '/contracts/';

export const SITE_API_BY_REALM_NAME = () => {
  return process.env.REACT_APP_RIVERUS_CLM_API + 'contracts/';
};

export const HOST = '' + process.env.REACT_APP_RIVERUS_CLM_APP_HOST;

export const AUTHURL = '' + process.env.REACT_APP_AUTH_URL;

export const WEBSOCKET_API = process.env.REACT_APP_RIVERUS_CLM_WEBSOCKET_URL;

export const AVAILABLESITES = [
  {
    identifier: 'auth',
    domainName: 'riverus.in',
  },
  {
    identifier: 'contracts',
    domainName: 'contracts.riverus.in',
  },
];

// KEYCLOAK
export const KEYCLOAK_URL: string =
  '' + process.env.REACT_APP_RIVERUS_CLM_AUTH_KEYCLOAK_URL;
export const KEYCLOAK_CLIENT_ID: string =
  '' + process.env.REACT_APP_RIVERUS_CLM_AUTH_KEYCLOAK_CLIENTID;

// Contract PageSize

export const contractPageSize: number = 10;
